import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=000b4f0d&scoped=true"
import script from "./Message.vue?vue&type=script&setup=true&lang=js"
export * from "./Message.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Message.vue?vue&type=style&index=0&id=000b4f0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000b4f0d",
  null
  
)

export default component.exports